/* eslint-disable react/prop-types */
"use client";

import React from "react";
import { AppModalIconButton } from "../common/AppModalShell";

const EventToolsBackButton = ({
  onClick,
  label = "Back",
  disabled = false,
}) => (
  <AppModalIconButton
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
  >
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" aria-hidden="true">
      <path
        d="M14.2 5.4L8.1 11.5L14.2 17.6"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </AppModalIconButton>
);

export default EventToolsBackButton;
